import React, { useRef, useState } from "react";
import styles from "./CartBundleOrder.module.scss";
import { Outlet } from "react-router-dom";
import NavTabs from "../../components/mui/tabs/NavTab";
import StatusCard from "../../components/uiComponents/statusCard/StatusCard";
const tabs = [
  {
    id: "1",
    title: "Pending",
    link: "/cartBundleOrdersDispatcher",
  },
  {
    id: "3",
     title: "Intransit",
    link: "/cartBundleOrdersDispatcher/inTransit",
  },
  {
    id: "2",
    title: "completed",
    link: "/cartBundleOrdersDispatcher/completed",
  },
];

const CartBundleOrdersDispatcher = () => {
  return (
    <div className={styles.container}>
    <StatusCard
        leftContent="ORDERS" // or any icon/component
      />
      <div className={styles.top}>
        <NavTabs data={tabs} variant={"fullWidth"} />
      </div>

      <div className={styles.bottom}>
        <Outlet />
      </div>
    </div>
  );
};

export default CartBundleOrdersDispatcher;
